import React from 'react';

export const GrayInfoIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 24, width = 25, className = '' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    className={className}
    viewBox="0 0 25 24"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#2A2A2A"
      d="M1.007 12c0-6.075 4.96-11 11.08-11 6.119 0 11.08 4.925 11.08 11s-4.961 11-11.08 11c-6.12 0-11.08-4.925-11.08-11Zm12.087-2v7H11.08v-7h2.014Zm-1.007-3c-.553 0-1.008.448-1.008 1s.455 1 1.008 1c.552 0 1.007-.448 1.007-1s-.455-1-1.007-1Z"
    />
  </svg>
);
